/**
 * 卡片注销页面
 */

import { useCallback } from 'react'
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import PageLayout from '@/components/PageLayout'
import Header from '@/components/Header'
import Back from '@/components/Back'
import CustomButton from '@/components/CustomButton'
import FixedBottom from '@/components/FixedBottom'
import { Toast } from 'react-vant'

// 卡片信息接口
interface CardInfo {
    maskedPan?: string
    balance?: number
    backgroundImage?: string
    cardIssued?: boolean
    status?: string
}

export default function CardCancel() {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const location = useLocation()
    const [searchParams] = useSearchParams()
    const cardId = searchParams.get('id') || ''
    const cardNo = searchParams.get('cardNo') || ''

    // 从路由 state 获取卡片信息
    const cardInfo: CardInfo = location.state || {}

    // 确认注销，跳转到选择验证方式页面
    const handleConfirm = useCallback(() => {
        navigate('/card-v2/card-cancel/select-verification', {
            state: {
                cardId,
                cardNo,
                ...cardInfo
            }
        })
    }, [navigate, cardId, cardNo, cardInfo])

    return (
        <PageLayout>
            <Header
                leftChildren={<Back />}
            />

            <div className="flex-1 flex flex-col items-center pt-20 px-5">
                {/* 图标 */}
                <div className="w-24 h-24 rounded-full bg-[#FDECED] flex items-center justify-center">
                    <div className="w-18 h-18 rounded-full bg-[#F5222D] flex items-center justify-center">
                        <img src="/images/card-v2/cancel-white.svg" alt="" />
                    </div>
                </div>

                {/* 标题 */}
                <div className="text-xl font-semibold text-[#1D2129] mt-6">
                    {t('销卡提醒')}
                </div>

                {/* 描述列表 */}
                <div className="mt-3 w-full px-5">
                    <ul className="space-y-2 text-base text-[#667085]">
                        <li className="flex items-start">
                            <span className="w-1.5 h-1.5 rounded-full bg-[#667085] mt-2 mr-3 flex-shrink-0" />
                            <span>{t('本卡资产会自动归集至您的总账户')}</span>
                        </li>
                        <li className="flex items-start">
                            <span className="w-1.5 h-1.5 rounded-full bg-[#667085] mt-2 mr-3 flex-shrink-0" />
                            <span>{t('此操作不可逆，还请您仔细确认后再执行')}</span>
                        </li>
                    </ul>
                </div>
            </div>

            {/* 底部按钮 */}
            <FixedBottom>
                <CustomButton onClick={handleConfirm}>
                    {t('确认销卡')}
                </CustomButton>
            </FixedBottom>
        </PageLayout>
    )
}

